export default __webpack_public_path__ + "static/Parveen-8a7f3dfa0ee6cebaf5f9b9f6c3248833.png";